var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-text',{staticStyle:{"color":"#4F4F4F"}},[_c('v-row',{staticClass:"pa-3"},[_vm._v("\n    Sorry, that link has expired. Please ask your agency owner to go to License Management and click \"resend link\".\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }